// The full X12 PID01 Item Description Type code list (DE 349) — shared by
// every "is this description free-form or coded" position across the 850's
// PID (Product/Item Description) and PKG (Marking, Packaging, Loading)
// segments, which both use the identical list for the same purpose.
// Transcribed from the reference document
// "00 - Envelope and Common Qualifiers.txt"'s "PID01 - Item Description
// Type" section.
//
// Each entry's `label` is the short name (used for the coded value's inline
// display); see dictionary/types.ts's `CodeListEntry`.

import type {CodeListEntry} from './types';

export const ITEM_DESCRIPTION_TYPE_CODES: CodeListEntry[] = [
  {code: 'F', label: 'Free-form'},
  {code: 'S', label: 'Structured (From Industry Code List)'},
  {code: 'X', label: 'Semi-structured (Code and Text)'},
];
